/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as _ from "lodash";
import { v4 as uuid } from "uuid";
import { Select, Button, Tooltip } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { fetchBalance } from "../../store/slices/balance";
import getUpdateIcon from "../../img/update";
import SpanNumberFormat from "../common/SpanNumberFormat";
import "./BalanceInfo.less";

const BalanceInfo = ({ handleAgreementChange = _.noop, agreementNumber = null }) => {
  // TODO REFACTOR!!!
  const dispatch = useDispatch();
  const { agreements, agreementsLoading } = useSelector((state) => state.agreements);
  const { balance } = useSelector((state) => state.balance);
  const [isBalanceShown, setBalanceShown] = useState(false);
  const [btnColor, setBtnColor] = useState("#BBB9B9");
  const isSelectDisabled = agreementNumber !== null;
  const agreement = agreements.find(
    ({ agreementNumber: an }) => String(an) === String(agreementNumber)
  );

  const getBalance = async (agreementId) => {
    await dispatch(fetchBalance(agreementId));
    if (!isBalanceShown) {
      setBalanceShown(true);
    }
  };

  const formik = useFormik({
    initialValues: {
      agreementId: agreement?.id,
    },
    onSubmit: async (values) => {
      await getBalance(values.agreementId);
    },
    enableReinitialize: true,
  });

  useEffect(() => {
    if (!formik.values.agreementId) setBtnColor("#BBB9B9");
    if (formik.values.agreementId) setBtnColor("#00BB77");
  }, [formik.values.agreementId]);

  const isSubmitDisabled = formik.values.agreementId === "all" || !formik.values.agreementId;

  const handleChange = (value) => {
    formik.setFieldValue("agreementId", value);
    handleAgreementChange(value);
  };

  const renderSelect = () =>
    isSelectDisabled ? (
      <Select value={agreementNumber} disabled className="input_large balance-info__select">
        <Select.Option key="agreementNumber" value={agreementNumber}>
          {agreementNumber}
        </Select.Option>
      </Select>
    ) : (
      <Select
        value={formik.values.agreementId}
        onChange={handleChange}
        className="input_large balance-info__select"
        loading={agreementsLoading === "pending"}
      >
        {agreements.map(({ id, agreementNumber: aggNumber }) => (
          <Select.Option key={uuid()} value={id}>
            {aggNumber}
          </Select.Option>
        ))}
      </Select>
    );

  const onBtnMouseEnter = () => {
    if (formik.values.agreementId) setBtnColor("#009C63");
    if (!formik.values.agreementId) setBtnColor("#BBB9B9");
  };

  const onBtnMouseLeave = () => {
    if (formik.values.agreementId) setBtnColor("#00BB77");
    if (!formik.values.agreementId) setBtnColor("#BBB9B9");
  };

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="balance-info__container balance-info"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "180px",
        backgroundColor: "white",
        marginTop: "10px",
        paddingLeft: "26px",
      }}
    >
      <span style={{ fontSize: "15px", marginBottom: "5px" }}>Номер договора</span>
      {renderSelect()}
      <Tooltip title={isSubmitDisabled ? "Необходимо выбрать договор" : ""}>
        <Button
          type="link"
          htmlType="submit"
          loading={formik.isSubmitting}
          icon={getUpdateIcon(btnColor)}
          style={{ width: "150px", paddingLeft: "0px", marginTop: "15px", marginBottom: "4px" }}
          disabled={isSubmitDisabled}
          onMouseEnter={onBtnMouseEnter}
          onMouseLeave={onBtnMouseLeave}
        >
          <span
            style={{ color: btnColor, bottom: "4px", position: "relative", paddingLeft: "8px" }}
          >
            Рассчитать баланс
          </span>
        </Button>
      </Tooltip>
      <span style={{ fontSize: "15px" }}>
        Баланс:
        <span style={{ marginLeft: "15px" }}>
          {isBalanceShown && SpanNumberFormat({ amount: balance.balance })}
        </span>
      </span>
    </form>
  );
};

export default BalanceInfo;
